function tptPauseAllVideo() {
  document.querySelectorAll('video').forEach((video) => video.pause());
}

function tptMutedAllVideo() {
  document.querySelectorAll('video').forEach((video) => (video.muted = true));
}

if (!customElements.get('tpt-video-item')) {
  customElements.define(
    'tpt-video-item',
    class TptVideoItem extends HTMLElement {
      constructor() {
        super();

        this.playBtn = this.querySelector('tpt-play-video');
        this.poster = this.querySelector('.tpt-video-poster');

        if (this.playBtn) {
          this.playBtn.addEventListener('click', this.playVideo.bind(this));
        }

        if (this.poster) {
          this.poster.addEventListener('click', this.playVideo.bind(this));
        }
      }

      playVideo() {
        const videoMain = this.querySelector('.tpt-video-main');
        if (!videoMain) return;

        const isActive = this.playBtn && this.playBtn.classList.contains('active');

        if (isActive) {
          // 暂停当前视频，恢复封面
          videoMain.classList.remove('active');
          videoMain.pause();
          videoMain.muted = true;
          if (this.poster) this.poster.style.display = '';
          if (this.playBtn) this.playBtn.classList.remove('active');
          return;
        }

        // 静音所有视频
        tptMutedAllVideo();

        // 移除所有播放按钮 active 状态
        document.querySelectorAll('tpt-play-video').forEach((btn) => {
          btn.classList.remove('active');
        });

        // 暂停同组其他视频
        if (this.closest('tpt-group-video[data-only-one-video="true"]')) {
          this.closest('tpt-group-video')
            .querySelectorAll('video')
            .forEach((video) => video.pause());
        }

        // 重置所有 item
        document.querySelectorAll('tpt-video-item').forEach((item) => {
          item.classList.remove('loaded');

          const vm = item.querySelector('.tpt-video-main');
          if (vm) {
            vm.classList.remove('active');
            vm.pause();
          }

          const p = item.querySelector('.tpt-video-poster');
          if (p) p.style.display = '';
        });

        // 激活当前 item：懒加载视频 src
        this.classList.add('loaded');

        if (!videoMain.src && videoMain.dataset.src) {
          videoMain.src = videoMain.dataset.src;
        }

        videoMain.classList.add('active');
        videoMain.muted = false;
        videoMain.play();

        if (this.poster) this.poster.style.display = 'none';
        if (this.playBtn) this.playBtn.classList.add('active');
      }
    }
  );
}
